import type { ContractDetails } from '@/api/schemas';
import { Field } from '@/components/Field';
import { Panel } from '@/components/ui/panel';
import { SectionHeading } from '@/components/ui/section-heading';
import { orNotAvailable } from '@/lib/display';

export function DealerSection({ contract }: { contract: ContractDetails }) {
  return (
    <div>
      <SectionHeading>Dealer</SectionHeading>
      <Panel variant="action">
        <div className="space-y-3">
          <Field
            label="Dealer Name"
            value={orNotAvailable(contract.dealerName)}
            strong={false}
          />
          <Field
            label="Dealer Account"
            value={contract.dealerAccount}
            strong={false}
          />
        </div>
      </Panel>
    </div>
  );
}
